// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__dvLOl","card":"NotFound_card__8jYUZ","title":"NotFound_title__OQ-MU","link":"NotFound_link__k4nv4"};